import { useEffect, useRef } from 'react';

export default function InfiniteScroll({ onVisit, onLeave, className, hasMore = true }) {
  const elementRef = useRef(null);

  useEffect(() => {
    if (!hasMore) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        onVisit?.();
      } else {
        onLeave?.();
      }
    });

    const element = elementRef.current;
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [hasMore, onVisit, onLeave]);

  return <span
    className={className}
    style={{ visibility: 'hidden' }}
    ref={elementRef}
  />
}
